import { Nav } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { trackEvent } from '../../services/analytics/analyticsService';
import { ANALYTICS_EVENTS } from '../../services/analytics/analyticsEvents';

const VIEW_ROUTES = {
    companies: '/discovery/companies',
    jobs: '/discovery/jobs',
};

// Mobile-only counterpart to the desktop Companies/Jobs toggle rendered inside
// DiscoveryFilterBar (which is hidden on mobile via hideTypeToggleOnMobile).
const MobileDiscoveryViewSwitch = ({ activeView, routes = VIEW_ROUTES }) => {
    const navigate = useNavigate();

    const handleViewChange = (view) => {
        if (view === activeView) return;

        trackEvent(ANALYTICS_EVENTS.DISCOVERY_VIEW_SWITCHED, {
            discoveryType: activeView,
            fromViewMode: activeView,
            toViewMode: view,
            level: 1,
            source: 'companies_jobs_toggle_mobile',
        });

        navigate(routes[view]);
    };

    return (
        <Nav variant="pills" className="nav-pills-view-toggle mobile-discovery-view-switch">
            <Nav.Item>
                <Nav.Link active={activeView === 'companies'} onClick={() => handleViewChange('companies')}>
                    Companies
                </Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link active={activeView === 'jobs'} onClick={() => handleViewChange('jobs')}>
                    Jobs
                </Nav.Link>
            </Nav.Item>
        </Nav>
    );
};

export default MobileDiscoveryViewSwitch;
